// Action buttons component for process and download actions
import React from 'react';
import { VStack, Button } from '@chakra-ui/react';
import { Zap } from 'lucide-react';
import { ImageItem } from '../types';

interface ActionButtonsProps {
  currentImage: ImageItem | undefined;
  isProcessing: boolean;
  isCropping: boolean;
  needsProcessing: boolean;
  onProcess: () => void;
  onDownload: () => void;
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  // currentImage,
  isProcessing,
  isCropping,
  needsProcessing,
  onProcess,
  // onDownload,
}) => {
  return (
    <VStack spacing={3} align="stretch">
      {/* Process Button */}
      <Button
        w="full"
        size="lg"
        py={6}
        bg="brand.primary.DEFAULT"
        color="white"
        fontWeight="bold"
        fontFamily="secondary"
        leftIcon={<Zap size={18} />}
        _hover={{ bg: 'brand.primary.hover' }}
        _active={{ transform: 'scale(0.98)' }}
        onClick={onProcess}
        isLoading={isProcessing}
        loadingText="Processing..."
        isDisabled={isCropping || !needsProcessing}
      >
        Process Image
      </Button>

      {/* Download Button */}
      {/* {currentImage?.processedUrl && (
        <Button
          w="full"
          size="lg"
          py={6}
          bg="status.success"
          color="white"
          fontWeight="bold"
          fontFamily="secondary"
          leftIcon={<Download size={18} />}
          _hover={{ opacity: 0.9 }}
          _active={{ transform: 'scale(0.98)' }}
          onClick={onDownload}
        >
          Download Image
        </Button>
      )} */}
    </VStack>
  );
};
